import useReactRouter from 'use-react-router';

export default function useGroupNestingLevel() {
  const { history } = useReactRouter();
  const groupNestingLevel = (history.location.state && history.location.state.groupNestingLevel) || 0;
  return groupNestingLevel;
}
